import React, { useEffect } from "react";
import CardLayoutContainer from "components/foundation/templates/CardLayout";
import { useGetPushNotification } from "features/pushNotification/queries";
import PushNotificationItem from "components/pushNotification/pushNotificationItem";
import useMediaView from "features/common/hooks/useMediaView";
import styled from "styled-components";
import Board from "components/Common/Board/Board";
import { useInView } from "react-intersection-observer";
import Button from "components/foundation/Button";
import { useUpdatePushNotifications } from "features/pushNotification/mutation";
import { useGetUnreadPushNotificationCount } from "features/pushNotification/queries";

const PushNotificationPage = () => {
  const { data, fetchNextPage, isFetching, hasNextPage } =
    useGetPushNotification({
      size: 10,
    });

  const updatePushNotificationsMutations = useUpdatePushNotifications();
  const unreadPushNotificationCount = useGetUnreadPushNotificationCount({});

  const unreadTotalCount = unreadPushNotificationCount.data?.data.result.count;

  const isSmallView = useMediaView("small");
  const [ref, inView] = useInView({ threshold: 1 });

  useEffect(() => {
    if (inView && !isFetching && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, isFetching, hasNextPage, fetchNextPage]);

  return isSmallView ? (
    <Wrapper>
      {data && data.length > 0 ? (
        <>
          <PushNotificationHeader>
            <PushNotificationTotalCount>
              총 {unreadTotalCount}건
              <DescriptionText> (미열람)</DescriptionText>
            </PushNotificationTotalCount>
            <Button
              variant="tertiary"
              disabled={unreadTotalCount === 0}
              onClick={() =>
                updatePushNotificationsMutations.mutate(
                  {},
                  {
                    onSuccess: () => {
                      unreadPushNotificationCount.refetch();
                    },
                  },
                )
              }
            >
              모두 읽음
            </Button>
          </PushNotificationHeader>

          <MobileContainer>
            <PushNotificationItem pushNotificationData={data} />
            <div ref={ref} />
          </MobileContainer>
        </>
      ) : (
        <NoPushNotificationWrapper>
          <NoPushNotification>알림함이 비어있습니다.</NoPushNotification>
        </NoPushNotificationWrapper>
      )}
    </Wrapper>
  ) : (
    <CardLayoutContainer.Container
      header={{
        title: "알림",
      }}
      bodyStyle={{ gap: "0rem" }}
    >
      {data && data.length > 0 ? (
        <>
          <PushNotificationHeader>
            <PushNotificationTotalCount>
              총 {unreadTotalCount}건
              <DescriptionText> (미열람)</DescriptionText>
            </PushNotificationTotalCount>
            <Button
              variant="tertiary"
              disabled={unreadTotalCount === 0}
              onClick={() =>
                updatePushNotificationsMutations.mutate(
                  {},
                  {
                    onSuccess: () => {
                      unreadPushNotificationCount.refetch();
                    },
                  },
                )
              }
            >
              모두 읽음
            </Button>
          </PushNotificationHeader>

          <PushNotificationItem pushNotificationData={data} />
          <div ref={ref} />
        </>
      ) : (
        <NoPushNotification>알림함이 비어있습니다.</NoPushNotification>
      )}
    </CardLayoutContainer.Container>
  );
};

export default PushNotificationPage;

const MobileContainer = styled(Board)`
  width: 100%;
  border-radius: 2rem 2rem 0rem 0rem;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const NoPushNotificationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const NoPushNotification = styled.div`
  color: ${({ theme }) => theme.color.text.secondary};
  ${({ theme }) => theme.typography.body3.medium};
`;

const PushNotificationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1.4rem 1.6rem;
`;

const PushNotificationTotalCount = styled.div`
  ${({ theme }) => theme.typography.body1.semibold}
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 0.4rem;
`;

const DescriptionText = styled.div`
  color: ${({ theme }) => theme.color.text.tertiery};
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.7378rem;
  letter-spacing: -0.021rem;
`;
